/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {
  jobCreateErrorSelector,
  jobCreateLoadingSelector,
  jobCreateResultSelector,
  jobCreateSelectedDevicesSelector,
  jobCreateSelectedJobSelector,
  jobcreateShowAddDevicesSelector,
  jobCreateShowDialogSelector,
  jobSearchEngineshowAddDevicesSelector
} from './state-selectors';

/**
 * React Hook to provide selector/state for Job Create functionality.
 *
 *  ```typescript
 *   import {useJobCreate} from '@ion/applications/src/components/jobs/useJobCreate';
 *
 *   const {
 *     jobCreateErrorSelector,
 *     jobCreateLoadingSelector,
 *     jobCreateResultSelector,
 *     jobCreateSelectedDevicesSelector,
 *     jobCreateSelectedJobSelector,
 *     jobCreateShowDialogSelector
 *   } = useJobCreate();
 *  ```
 */
export const useJobCreate = () => {
  const jobCreateResult          = useSelector(jobCreateResultSelector);
  const jobCreateSelectedDevices = useSelector(jobCreateSelectedDevicesSelector);
  const jobCreateSelectedJob     = useSelector(jobCreateSelectedJobSelector);
  const jobCreateShow            = useSelector(jobCreateShowDialogSelector);
  const jobCreateLoading         = useSelector(jobCreateLoadingSelector);
  const jobCreateError           = useSelector(jobCreateErrorSelector);
  const jobCreateShowAddDevices  = useSelector(jobcreateShowAddDevicesSelector);
  const jobSearchAddDevices      = useSelector(jobSearchEngineshowAddDevicesSelector);

  return {
    jobCreateResult,
    jobCreateSelectedDevices,
    jobCreateSelectedJob,
    jobCreateShow,
    jobCreateLoading,
    jobCreateError,
    jobCreateShowAddDevices : jobCreateShowAddDevices || jobSearchAddDevices
  };
};

export default useJobCreate;
